export const QuickFiltersEvents = {
    QuickFilterCreated: 'quick filter created',
    QuickFilterUpdated: 'quick filter updated',
    QuickFilterSelected: 'quick filter selected',
    QuickFiltersModalOpened: 'quick filters modal opened',
}
